import { render, staticRenderFns } from "./ShitTodo.vue?vue&type=template&id=1bbfaaac&"
import script from "./ShitTodo.vue?vue&type=script&lang=js&"
export * from "./ShitTodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports